import React, { Component } from 'react';
import ReactDOM from 'react-dom'

import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import { dateDataTimeFormatter,dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';



  function buttonFormatter(cell, row,extra) {
    return (
      <div>
          <Link to={`/showcertrequest/${cell}`} className="btn btn-default btn-sm"><i className="fa fa-eye"></i> نمایش </Link>
         
      </div>
    );
  }


class NewCertReqList extends React.Component {
    
    constructor(props) {
        super(props);
       
        this.state = {
        
        
        };

       
      }
  
    render() { 
      const {list}=this.props;
      console.log('TABLE',list)
        return ( 
            <div>
                
                <BootstrapTable data={list && list}  striped hover
                    headerContainerClass='rightAlignStyle'
                    bodyContainerClass='rightAlignStyle'>
                
                    <TableHeaderColumn isKey dataField='Id' hidden >id</TableHeaderColumn>         
                    <TableHeaderColumn dataField='CertificationType' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }>نوع گواهی</TableHeaderColumn>
                    <TableHeaderColumn dataField='Patient' formatExtraData="FullName" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }>مراجع</TableHeaderColumn>
                    <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter } formatExtraData={this}></TableHeaderColumn>
                </BootstrapTable>

                        
                  
            </div>
        
        );
    }
}

 
export default NewCertReqList;